import { render } from "./FrontDeskForm.vue?vue&type=template&id=10c9e203"
import script from "./FrontDeskForm.vue?vue&type=script&lang=js"
export * from "./FrontDeskForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__